module.exports = {"id":"200536","name":"Nico Schulz","rating":"75","photo":"./data/images/photos/4/200536.png","club":{"name":"1899 Hoffenheim","logo":"./data/images/clubs/1899Hoffenheim.png"},"positions":["DG","MG","DLG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NicoSchulz0.json
// module id = 3183
// module chunks = 0